import { GridColDef } from '@mui/x-data-grid-pro';
import { format, parseISO } from 'date-fns';
import { ExternalLink } from 'lucide-react';

import { MuiStyles } from '@/components/TailwindComponents';
import { IAgency, IKase, IUser } from '@/models';
import { IBooking } from '@/pages/JMS/Managament/types/booking';
import { formatPersonName } from '@/utils';

const agencyBookedFor = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => {
    return (params?.row?.details?.agency as IAgency)?.name;
  },
});

const initialBookingDate = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => {
    if (!params.row?.details?.initialBooking) {
      return;
    }
    return format(parseISO(params.row?.details?.initialBooking), 'MM/dd/yyyy');
  },
});

const lastIntakeDate = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => {
    if (!params.row?.details?.lastIntake) {
      return;
    }
    return format(parseISO(params.row?.details?.lastIntake), 'MM/dd/yyyy');
  },
});

const scheduledRelease = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => {
    if (!params.row?.details?.scheduledReleaseDate) {
      return;
    }
    return format(
      parseISO(params.row?.details?.scheduledReleaseDate),
      'MM/dd/yyyy',
    );
  },
});

const actualRelease = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => {
    if (!params.row?.details?.actualReleaseDate) {
      return;
    }
    return format(
      parseISO(params.row?.details?.actualReleaseDate),
      'MM/dd/yyyy',
    );
  },
});

const caseNumber = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) =>
    (params.row.details?.kase as IKase)?.number,
});

const bookingOfficer = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) =>
    formatPersonName(params.row.details?.bookingOfficer as IUser),
});

const bookingType = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => params.row.details?.type,
});

const bookingDisposition = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) =>
    params.row.details?.bookingDisposition,
});

const bookingNumber = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => params.row?.details?.number,
});

const status = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => params.row?.status,
});

const actions = (
  onView?: (inmateId?: string) => void,
): Partial<GridColDef> => ({
  sortable: false,
  filterable: false,
  renderCell: (params: { row: IBooking }) => {
    return (
      <div className="flex items-center pt-2">
        <ExternalLink
          width={17}
          height={17}
          className={MuiStyles.TableGridCellIcon}
          onClick={() => onView?.(params.row?._id)}
        />
      </div>
    );
  },
});

export const bookingHistoryCols = (onView?: (bookingId?: string) => void) => {
  return {
    bookingNumber,
    agency: agencyBookedFor,
    bookingType,
    bookingOfficer,
    initialBookingDate,
    lastIntakeDate,
    caseNumber,
    bookingDisposition,
    scheduledRelease,
    actualRelease,
    status,
    actions: () => actions(onView),
  };
};
